import React from 'react';

const ConfigToggle = ({ label, value, onChange, description }) => (
    <div>
        <div className="flex items-center justify-between mt-4">
            <label className="text-sm font-medium text-gray-700">{label}</label>
            <button
                onClick={() => onChange(!value)}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${value ? 'bg-blue-600' : 'bg-gray-200'
                    }`}
            >
                <span
                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${value ? 'translate-x-6' : 'translate-x-1'
                        }`}
                />
            </button>
        </div>
        {description && (
            <p className="mt-1 text-sm text-gray-500">{description}</p>
        )}
    </div>
);

export default ConfigToggle;